import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";

import { ClientSideSuspense } from "shared/components/common/client-side-suspense";
import { config } from "shared/data";
import { accountAtom } from "shared/lib/account";

import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import { useLoginDialogStateHelper } from "scmp-app/components/login-dialog/hooks";

import { DashboardContainer, Label, StyledIconAvatar } from "./styles";
export type HeaderFeaturesDashboardProps = HeaderFeatureCommonProps & {
  showUserLabel?: boolean;
  variant?: "default" | "postmag";
};

export const HeaderFeaturesDashboard: FunctionComponent<HeaderFeaturesDashboardProps> = ({
  showUserLabel = true,
  variant = "default",
  ...props
}) => {
  const { isLoggedIn } = useAtomValue(accountAtom);
  const { openLoginDialog } = useLoginDialogStateHelper();

  const handleLoginClick = () => {
    if (typeof window === "undefined") return;

    const redirectUrl = new URL(window.location.href);
    openLoginDialog({
      destination: redirectUrl.toString(),
      ga4CustomParameter: {
        trigger_point: "header",
      },
      title: "Sign In / Register",
    });
  };

  if (!showUserLabel && isLoggedIn) return null;

  return (
    <ClientSideSuspense>
      <DashboardContainer
        {...getResponsiveProps(props)}
        $isLight={isLoggedIn}
        $variant={variant}
        onClick={isLoggedIn ? undefined : handleLoginClick}
      >
        {isLoggedIn ? (
          <a
            aria-label="my account"
            href={config.account.scmpAccountHost}
            rel="noopener noreferrer"
            target="_blank"
          >
            <StyledIconAvatar />
            <Label>MY ACCOUNT</Label>
          </a>
        ) : (
          "SIGN IN"
        )}
      </DashboardContainer>
    </ClientSideSuspense>
  );
};

HeaderFeaturesDashboard.displayName = "HeaderFeaturesDashboard";
